import { TagsProps } from "~/components/Tags";
import { Headline, PillButton } from "~/ui-library";

type TagItem = TagsProps["tags"][number];

export type ArticleTagSubscriptionsProps = {
  onTagClick?: (tag: TagItem) => void;
  tags: TagItem[];
};

export const ArticleTagSubscriptions: React.FC<
  ArticleTagSubscriptionsProps
> = ({ tags, onTagClick }) => (
  <div className="flex flex-col gap-s px-s py-m">
    <Headline level={5} as="h5">
      Select more topics for your inbox
    </Headline>
    <div className="flex flex-wrap gap-s">
      {tags.map((tag) => (
        <PillButton key={tag.name} onClick={() => onTagClick?.(tag)}>
          {tag.name}
        </PillButton>
      ))}
    </div>
  </div>
);
